import { Dialog, DialogActions, DialogContent, Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

/**
 * @author IKlapouch
 * 01/17/2021
 */
export const DialogConformationGeneric = (props) => {
    const { t } = useTranslation();

    const {
        open,
        handleClose,
        message,
        translateMessage,
        maxWidth,
        hideCancel = false,   // <- nova prop opcional
        hideConfirm = false,  // <- nova prop opcional
    } = props;

    function handleKeyPress(event) {
        if (typeof props.onKeyPress === 'function') {
            props.onKeyPress(event);
            return;
        }

        // Enter só confirma se o botão Confirm estiver visível
        if (!hideConfirm && (event.code === 'Enter' || event.code === 'NumpadEnter')) {
            handleClose(true);
        }
    }

    const showActions = !hideCancel || !hideConfirm;

    return (
        <Dialog
            onKeyPress={handleKeyPress}
            open={open}
            onClose={() => handleClose(false)}
            fullWidth
            style={props.style}
            maxWidth={maxWidth || 'md'}
        >
            <DialogContent>
                <Typography>
                    {(translateMessage === undefined || translateMessage === true) ? t(message) : message}
                </Typography>
            </DialogContent>

            {showActions && (
                <DialogActions>
                    {!hideCancel && (
                        <Button
                            style={{ backgroundColor: '#F5B7B1' }}
                            onClick={() => handleClose(false)}
                            disableFocusRipple={false}
                        >
                            {t('cancel')}
                        </Button>
                    )}

                    {!hideConfirm && (
                        <Button
                            style={{ backgroundColor: '#82E0AA' }}
                            onClick={() => handleClose(true)}
                        >
                            {t('confirm')}
                        </Button>
                    )}
                </DialogActions>
            )}
        </Dialog>
    );
};